import { createPublicClient, http } from 'viem'
import { mainnet, sepolia } from 'viem/chains'

import { getWalletClient } from '@wagmi/core'

// const appChain = ['production'].includes(process.env.REACT_APP_ENV) ? mainnet : sepolia

const appChain = mainnet



const appPublicClient = () => {
  const client = createPublicClient({
    chain: appChain,
    transport: http()
  })

  return client
}
const appWallectClient = async () => {
  return await getWalletClient({
    chainId: appChain.id,
  });
}

export { appChain, appPublicClient,appWallectClient }